import { defineStyleConfig } from '@chakra-ui/react';

const baseStyle = {
  backgroundColor: 'purple.700',
};

export const tooltipTheme = defineStyleConfig({ baseStyle });
